import { NSTable } from '../../types/interfaces/NSTable';
import { ETableActionTypes } from '../../types/enums/ETableActionTypes';
import { getStateIfNotExist } from '../../utils/reducerUtils';
import { PackagesList } from '../../utils/reducer';

const actions: NSTable.IDispatchActions = {
  initState: (tableName: string) => ({
    type: ETableActionTypes.InitState,
    tableName,
  }),
  setPage: (tableName: string, page: number) => ({
    type: ETableActionTypes.SetPage,
    tableName,
    page,
  }),
  setSorting: (tableName: string, sorting: NSTable.ISortingArgument) => ({
    type: ETableActionTypes.SetSorting,
    tableName,
    sorting,
  }),
  setFiltering: (tableName: string, filtering: NSTable.IFilteringArgument[]) => ({
    type: ETableActionTypes.SetFiltering,
    tableName,
    filtering,
  }),
  setPopup: (tableName: string, name: string, popup: NSTable.IPopupArgument) => ({
    type: ETableActionTypes.SetPopup,
    tableName,
    name,
    popup,
  }),
  setCheckedRow: (tableName: string, checkedId: string) => ({
    type: ETableActionTypes.SetCheckedRow,
    tableName,
    checkedId,
  }),
  setAllRowsIsChecked: (tableName: string, idList: string[]) => ({
    type: ETableActionTypes.SetAllRowsIsChecked,
    tableName,
    idList,
  }),
};

const reducer: NSTable.TReducer = (state, action) => {
  switch (action.type) {
    case ETableActionTypes.InitState:
      if (state[action.tableName]) {
        return { ...state };
      }
      return { ...state, [action.tableName]: { page: 0 } };
    case ETableActionTypes.SetPage:
      return { ...state, [action.tableName]: { ...state[action.tableName], page: action.page } };
    case ETableActionTypes.SetSorting:
      return {
        ...state,
        [action.tableName]: { ...state[action.tableName], sorting: action.sorting },
      };
    case ETableActionTypes.SetFiltering:
      return {
        ...state,
        [action.tableName]: {
          ...state[action.tableName],
          filtering: action.filtering,
        },
      };
    case ETableActionTypes.SetPopup:
      return {
        ...state,
        [action.tableName]: {
          ...state[action.tableName],
          popups: {
            ...state[action.tableName].popups,
            [action.name]: {
              ...getStateIfNotExist(state[action.tableName].popups, action.name),
              ...action.popup,
            },
          },
        },
      };
    case ETableActionTypes.SetCheckedRow:
      const list = new PackagesList(state[action.tableName]?.checkedIds || [], action.checkedId);

      return {
        ...state,
        [action.tableName]: {
          ...state[action.tableName],
          checkedIds: list.containCheckedId() ? list.getListWithoutCheckedId() : list.getListWithCheckedId(),
        },
      };
    case ETableActionTypes.SetAllRowsIsChecked:
      const allIsChecked: boolean = !!!state[action.tableName]?.allIsChecked;

      const checkedIds = allIsChecked ? action.idList : [];

      return {
        ...state,
        [action.tableName]: {
          ...state[action.tableName],
          allIsChecked,
          checkedIds,
        },
      };
    default:
      throw new Error();
  }
};

export const tableStateReducer = { actions, reducer };
